module.exports = __webpack_public_path__ + "img/liusichao.e35d33c2.jpg";